// Product bundle choices to create an extraction. It's a collection of Parent and child product.
import { productBundleTemplatesService } from '@/services/estimation/product-bundle-templates.service';
import axios from 'axios';

const initialState = () => ({
  productBundleTemplates: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const CancelToken = axios.CancelToken;
let cancelTokens = {
  productBundleTemplates: null,
};

const actions = {
  // Get product bundle templates
  getProductBundleTemplates({ commit }) {
    if (cancelTokens.productBundleTemplates) {
      cancelTokens.productBundleTemplates.cancel('Multiple requests.');
    }
    cancelTokens.productBundleTemplates = CancelToken.source();

    commit('GET_PRODUCT_BUNDLE_TEMPLATES');
    return productBundleTemplatesService
      .getProductBundleTemplates({ cancelToken: cancelTokens.productBundleTemplates })
      .then(
        (response) => commit('SUCCESS', response),
        (error) => {
          if (axios.isCancel(error)) return;
          commit('ERROR', error.response);
          throw error;
        },
      );
  },
  // Get product bundle template by id
  getProductBundleTemplateById() {},
  // Update product bundle template
  updateProductBundleTemplate() {},
  // Add a product bundle template
  addProductBundleTemplate() {},
};

const mutations = {
  GET_PRODUCT_BUNDLE_TEMPLATES(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.productBundleTemplates = [];
  },
  SUCCESS(state, productBundleTemplates) {
    state.status = {
      error: null,
      pending: false,
      resolved: true,
      rejected: false,
    };
    state.productBundleTemplates = productBundleTemplates;
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      error: error,
      pending: false,
      rejected: true,
    };
  },
};

const getters = {
  productBundleTemplates: (state) => state.productBundleTemplates,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const productBundleTemplates = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
